import { h, defineComponent } from 'vue';
import { level, pageTitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { SensorIndexPage } from './tabs/SensorIndexPage';
import { GatewayIndexPage } from './tabs/GatewayIndexPage';
import * as qs from '@/ui/queryState';
import { secondaryNavbar, TabItem } from '@/ui/components/navigation/SecondaryNavbar';
import { SensorsTabNames, queryTabName } from '@/ui/components/navigation/constants';
import { Button } from '@/ui/components/Button';

export const SensorsPage = defineComponent({
  name: 'SensorsPage',
  setup() {
    const activeTab = qs.stringEnum<SensorsTabNames>(
      queryTabName,
      Object.values(SensorsTabNames),
      SensorsTabNames.SENSORS,
      false,
    );

    const secondaryTabItems : TabItem[] = [
      {
        value: SensorsTabNames.SENSORS,
        label: t('common.sensors'),
        icon: 'sensor',
        underLineColor: 'blue',
      },
      {
        value: SensorsTabNames.GATEWAYS,
        label: t('common.gateways'),
        icon: 'router',
        underLineColor: 'orange',
      },
    ];

    const getTab = () => {
      switch (activeTab.value) {
        case SensorsTabNames.SENSORS:
          return SensorIndexPage;
        case SensorsTabNames.GATEWAYS:
          return GatewayIndexPage;
        default:
          throw new Error('Invalid tab selected. Please use SensorsTabEnum enumeration');
      }
    };

    return function render() {
      return h('div', [
        level(
          [
            pageTitle(t('common.sensors')),
          ],
          [
            activeTab.value === SensorsTabNames.SENSORS
              ? h(Button, {
                attrs: {
                  iconLeft: 'plus',
                  tag: 'router-link',
                  to: { name: 'sensorCreate' },
                },
              }, t('sensors.add')) : null,
          ],
        ),
        secondaryNavbar({
          props: { value: activeTab.value, tabItems: secondaryTabItems },
          on: {
            input: (value: SensorsTabNames) => {
              activeTab.value = value;
            },
          },
        }),
        h(getTab()),
      ]);
    };
  },
});
